import * as View from "../../../src/Containers/ContractType/View.scss";
import { textDotsLoading, dotsLoading, getStatusBall, Color } from "../../ViewUtils.js";
import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { ContractTypeGeneral$reflection } from "../ContractTypeGeneral/Model.js";
import { class_type, list_type, lambda_type, unit_type, tuple_type, union_type, record_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { GlobalDependencies$reflection, LoadState$2, getTranslationFrom, LoadState$2$reflection } from "../../Global.js";
import { CreateContractTypeDTO, CreateContractTypeDTO$reflection, Page, Page$reflection } from "./Model.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { warning, info, error } from "../../Components/Message/Message.js";
import * as react from "react";
import { compareArrays, compare, uncurry, equals } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { RouterModule_encodeParts, RouterModule_urlSegments } from "../../fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { Locale_get_FromSelectedLanguage, Result_toBool, strToOpt, optToStr, formatUrl } from "../../Utils.js";
import { append as append_1, ofArray, sortBy, cons, map, singleton } from "../../fable_modules/fable-library.3.7.20/List.js";
import { HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { Result_Map, Result_Bind, FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { ProductModule_toInt, ProductModule_fromString, ProductModule_toString, ProductModule_getAllProducts, Product } from "../../DomainTypes.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_1 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpMap__get_Item, ofSeq } from "../../fable_modules/fable-library.3.7.20/Map.js";
import { InputType, lengthLTE, isNotNullOrWhitespace, isPlainText } from "../../Validation/Common.js";
import { ButtonProps_get_getDefault, ButtonProps, defaultProps, ButtonKind, wrappedButton } from "../../Components/Button/Button.js";
import { singleton as singleton_2, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_1 } from "../../Components/StatefulFormFields/Text.js";
import { Browser_Types_Event__Event_get_Checked, Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { CheckboxInput, CheckboxInput_get_getDefault, inputCheckbox, SelectOption, ValueProp, SelectOption_get_getDefault, selectOption } from "../../Components/FormFields/FormFields.js";
import { map as map_1 } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { parse } from "../../fable_modules/fable-library.3.7.20/Int32.js";
import { renderWithButtonProps } from "../../Components/Modals/Standard.js";
import { ModalSize } from "../../Components/Modal/Modal.js";
import { createContractType, loadContractType as loadContractType_1, loadAllContractTypes as loadAllContractTypes_1 } from "./Api.js";
import { ContractTypeGeneralProps, view as view_1 } from "../ContractTypeGeneral/View.js";
import { ActivationStateProps, view as view_2 } from "../ActivationState/View.js";
import { ContractTypeMortgageProps, view as view_3 } from "../ContractTypeMortgage/View.js";
import { SubproductsProps, renderSubproducts } from "../Subproducts/View.js";
import { ContractTypeSubproductApi_create, ContractTypeSubproductApi_delete, ContractTypeSubproductApi_update, ContractTypeSubproductApi_load } from "../Subproducts/Api.js";
import { SubproductLevel, NormalizedSubproduct_toSubproductDTO_Z60DB963E, NormalizedSubproduct_ofSubproductDTO_Z9763C53 } from "../Subproducts/Model.js";
import { loadSubproductDefinitions } from "../SubproductDefinition/Api.js";
import { renderCustomTable } from "../../Components/Table/Table.js";
import { loadPricelist } from "../ContractTypeGeneral/Api.js";


function renderStatusBallHtml(getTranslation, isActive) {
    const patternInput = isActive ? [new Color(0), getTranslation("Common.Active")] : [new Color(2), getTranslation("Common.Inactive")];
    return getStatusBall(patternInput[0], patternInput[1]);
}

class TopSectionProps extends Record {
    constructor(ContractTypeDetails, CurrentContractTypePage, ContractTypeCode) {
        super();
        this.ContractTypeDetails = ContractTypeDetails;
        this.CurrentContractTypePage = CurrentContractTypePage;
        this.ContractTypeCode = ContractTypeCode;
    }
}

function TopSectionProps$reflection() {
    return record_type("Containers.ContractType.View.TopSectionProps", [], TopSectionProps, () => [["ContractTypeDetails", LoadState$2$reflection(ContractTypeGeneral$reflection(), string_type)], ["CurrentContractTypePage", Page$reflection()], ["ContractTypeCode", string_type]]);
}

const renderTopSection = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_12, children_10, children_8, children_32, children_30, children_16, props_15, children_14, children_20, props_19, children_18, children_24, props_23, children_22, children_28, props_27, children_26;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const matchValue = props.ContractTypeDetails;
    switch (matchValue.tag) {
        case 3: {
            const children_2 = [error(matchValue.fields[0].split(""))];
            return react.createElement("div", {}, ...children_2);
        }
        case 1: {
            return dotsLoading;
        }
        case 2: {
            const details = matchValue.fields[0];
            const getSubnavClasses = (currentPage, thisPage) => {
                const baseClass = "container__subnav";
                if (equals(currentPage, thisPage)) {
                    return baseClass + " container__subnav--active";
                }
                else {
                    return baseClass;
                }
            };
            const currentUrlSegments = RouterModule_urlSegments(window.location.hash, 1);
            const getUrl = (additionalSegments) => RouterModule_encodeParts(formatUrl(currentUrlSegments, singleton(props.ContractTypeCode), additionalSegments), 1);
            const generalUrl = getUrl(singleton("General"));
            const activationStateUrl = getUrl(singleton("ActivationState"));
            const subproductsUrl = getUrl(singleton("Subproducts"));
            const mortgageUrl = getUrl(singleton("Mortgage"));
            const statusBallHtml = renderStatusBallHtml(getTranslation, details.Active);
            const children_34 = [(children_12 = [(children_10 = [(children_8 = [react.createElement("span", {
                className: "container__status",
            }, statusBallHtml), react.createElement("h2", {
                className: "container__display",
            }, details.Display)], react.createElement("div", {
                className: "contractType-overview__container",
            }, ...children_8))], react.createElement("div", {}, ...children_10))], react.createElement("div", {
                className: "contractType-overview__container",
            }, ...children_12)), (children_32 = [(children_30 = [(children_16 = [(props_15 = [new HTMLAttr(99, "contractType-view-general"), new HTMLAttr(65, getSubnavClasses(props.CurrentContractTypePage, new Page(1, details.ContractTypeCode)))], (children_14 = [getTranslation("ContractType.Overview.General")], react.createElement("div", keyValueList(props_15, 1), ...children_14)))], react.createElement("a", {
                className: "container__navigation",
                href: generalUrl,
            }, ...children_16)), (children_20 = [(props_19 = [new HTMLAttr(99, "contractType-view-activationState"), new HTMLAttr(65, getSubnavClasses(props.CurrentContractTypePage, new Page(3, details.ContractTypeCode)))], (children_18 = [getTranslation("ContractType.Overview.ActivationState")], react.createElement("div", keyValueList(props_19, 1), ...children_18)))], react.createElement("a", {
                className: "container__navigation",
                href: activationStateUrl,
            }, ...children_20)), (children_24 = [(props_23 = [new HTMLAttr(99, "contractType-view-subproducts"), new HTMLAttr(65, getSubnavClasses(props.CurrentContractTypePage, new Page(4, details.ContractTypeCode)))], (children_22 = [getTranslation("ContractType.Overview.Subproducts")], react.createElement("div", keyValueList(props_23, 1), ...children_22)))], react.createElement("a", {
                className: "container__navigation",
                href: subproductsUrl,
            }, ...children_24)), (children_28 = [(props_27 = [new HTMLAttr(99, "contractType-view-mortgage"), new HTMLAttr(65, getSubnavClasses(props.CurrentContractTypePage, new Page(2, details.ContractTypeCode)))], (children_26 = [getTranslation("ContractType.Overview.Mortgage")], react.createElement("div", keyValueList(props_27, 1), ...children_26)))], react.createElement("a", {
                className: "container__navigation",
                href: mortgageUrl,
            }, ...children_28))], react.createElement("div", {
                className: "contractType-overview__container",
            }, ...children_30))], react.createElement("div", {
                className: "contractType-overview__border d-flex mt-4 mb-4 justify-content-between",
            }, ...children_32))];
            return react.createElement("section", {
                className: "contractType-overview",
            }, ...children_34);
        }
        default: {
            const children = [info(getTranslation("ContractType.Overview.Loading").split(""))];
            return react.createElement("div", {}, ...children);
        }
    }
}, void 0, uncurry(2, void 0), void 0, "renderTopSection", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\ContractType\\View.fs", 117);

export class ValidationField extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Display", "Code"];
    }
}

export function ValidationField$reflection() {
    return union_type("Containers.ContractType.View.ValidationField", [], ValidationField, () => [[], []]);
}

export class CreateContractTypeProps extends Record {
    constructor(SaveFn, LoadPriceListFn) {
        super();
        this.SaveFn = SaveFn;
        this.LoadPriceListFn = LoadPriceListFn;
    }
}

export function CreateContractTypeProps$reflection() {
    return record_type("Containers.ContractType.View.CreateContractTypeProps", [], CreateContractTypeProps, () => [["SaveFn", lambda_type(tuple_type(string_type, CreateContractTypeDTO$reflection()), unit_type)], ["LoadPriceListFn", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(string_type), string_type], FSharpResult$2, () => [[["ResultValue", list_type(string_type)]], [["ErrorValue", string_type]]])]))]]);
}

const renderCreateContractTypeButtonAndModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let arg_13, arg_14;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const modalIsOpen = react.useState(false);
    const displayState = react.useState("");
    const codeState = react.useState("");
    const productNrState = react.useState(new Product(0));
    const networkContractNrState = react.useState(void 0);
    const priceListCodeState = react.useState("");
    const contractTypePriceIdState = react.useState(1);
    const isActiveState = react.useState(true);
    const priceListLoadState = react.useState(new LoadState$2(0));
    react.useEffect(() => {
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(props.LoadPriceListFn(), (_arg) => {
            let arg_1;
            const result = _arg;
            return singleton_1.Combine((result.tag === 0) ? (((arg_1 = (new LoadState$2(2, map((x) => [x, x], result.fields[0]))), priceListLoadState[1](arg_1)), singleton_1.Zero())) : ((priceListLoadState[1](new LoadState$2(3, result.fields[0])), singleton_1.Zero())), singleton_1.Delay(() => singleton_1.Return()));
        })));
    }, []);
    const validationFields = ofSeq([[new ValidationField(0), (arg_4) => Result_Bind((str_2) => isPlainText(getTranslation, str_2), Result_Bind((str_1) => isNotNullOrWhitespace(getTranslation, str_1), lengthLTE(getTranslation, 50, new InputType(2), arg_4)))], [new ValidationField(1), (arg_6) => Result_Bind((str_5) => isPlainText(getTranslation, str_5), Result_Bind((str_4) => isNotNullOrWhitespace(getTranslation, str_4), lengthLTE(getTranslation, 16, new InputType(2), arg_6)))]], {
        Compare: compare,
    });
    const createContractTypeButtonHtml = wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("Contracts.ContractType.CreateNewContractType"), defaultProps.Content, (_arg_1) => {
        modalIsOpen[1](true);
    }, defaultProps.Disabled, "create-contract-type-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon));
    let bodyHtml;
    const children_1 = toList(delay(() => {
        let inputRecord, LabelText;
        return append(singleton_2(render_1()((inputRecord = TextProps$1_GetDefault(), (LabelText = (getTranslation("Common.Name") + "*"), new TextProps$1(displayState[0], inputRecord.Type, inputRecord.Classes, (e) => {
            const arg_7 = Browser_Types_Event__Event_get_Value(e);
            displayState[1](arg_7);
        }, inputRecord.Disabled, LabelText, "create-contract-type-display", FSharpMap__get_Item(validationFields, new ValidationField(0)), inputRecord.DynamicWidth, inputRecord.HTMLProps, inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name))))), delay(() => {
            let inputRecord_1, LabelText_1;
            return append(singleton_2(render_1()((inputRecord_1 = TextProps$1_GetDefault(), (LabelText_1 = (getTranslation("Common.Code") + "*"), new TextProps$1(codeState[0], inputRecord_1.Type, inputRecord_1.Classes, (e_1) => {
                const arg_8 = Browser_Types_Event__Event_get_Value(e_1);
                codeState[1](arg_8);
            }, inputRecord_1.Disabled, LabelText_1, "create-contract-type-code", FSharpMap__get_Item(validationFields, new ValidationField(1)), inputRecord_1.DynamicWidth, inputRecord_1.HTMLProps, inputRecord_1.OnBlur, inputRecord_1.OnFocus, inputRecord_1.AutoComplete, inputRecord_1.Name))))), delay(() => {
                let inputRecord_2, OptionValues, LabelText_2;
                return append(singleton_2(selectOption((inputRecord_2 = SelectOption_get_getDefault(), (OptionValues = ProductModule_getAllProducts(getTranslation), (LabelText_2 = getTranslation("Common.ProductType"), new SelectOption(new ValueProp(0, ProductModule_toString(productNrState[0]), (e_2) => {
                    const arg_9 = ProductModule_fromString(Browser_Types_Event__Event_get_Value(e_2));
                    productNrState[1](arg_9);
                }), "create-contract-product-select", OptionValues, inputRecord_2.Classes, LabelText_2, inputRecord_2.Disabled, inputRecord_2.HTMLProps)))))), delay(() => {
                    let matchValue, inputRecord_3, LabelText_3;
                    return append((matchValue = (priceListLoadState[0]), (matchValue.tag === 1) ? singleton_2(textDotsLoading) : ((matchValue.tag === 3) ? singleton_2(error(matchValue.fields[0].split(""))) : ((matchValue.tag === 2) ? singleton_2(selectOption((inputRecord_3 = SelectOption_get_getDefault(), (LabelText_3 = getTranslation("Common.PriceList"), new SelectOption(new ValueProp(0, priceListCodeState[0], (e_3) => {
                        const arg_10 = Browser_Types_Event__Event_get_Value(e_3);
                        priceListCodeState[1](arg_10);
                    }), "create-contract-pricelist-select", cons(["", "None"], matchValue.fields[0]), inputRecord_3.Classes, LabelText_3, inputRecord_3.Disabled, inputRecord_3.HTMLProps))))) : singleton_2(react.createElement(react.Fragment, {}))))), delay(() => {
                        let inputRecord_4, LabelText_4;
                        return append(singleton_2(render_1()((inputRecord_4 = TextProps$1_GetDefault(), (LabelText_4 = getTranslation("ContractType.General.NetworkContractNr"), new TextProps$1(optToStr(networkContractNrState[0]), "number", inputRecord_4.Classes, (e_4) => {
                            const arg_11 = map_1((value) => parse(value, 511, false, 32), strToOpt(Browser_Types_Event__Event_get_Value(e_4)));
                            networkContractNrState[1](arg_11);
                        }, inputRecord_4.Disabled, LabelText_4, "create-contract-network-contract-nr", inputRecord_4.ValidationFn, inputRecord_4.DynamicWidth, inputRecord_4.HTMLProps, inputRecord_4.OnBlur, inputRecord_4.OnFocus, inputRecord_4.AutoComplete, inputRecord_4.Name))))), delay(() => {
                            let inputRecord_5;
                            return append(singleton_2(render_1()((inputRecord_5 = TextProps$1_GetDefault(), new TextProps$1(optToStr(contractTypePriceIdState[0]), "number", inputRecord_5.Classes, (e_5) => {
                                const arg_12 = map_1((value_1) => parse(value_1, 511, false, 32), strToOpt(Browser_Types_Event__Event_get_Value(e_5)));
                                contractTypePriceIdState[1](arg_12);
                            }, inputRecord_5.Disabled, "ContractTypePriceId", "create-contract-contract-type-price-id", inputRecord_5.ValidationFn, inputRecord_5.DynamicWidth, inputRecord_5.HTMLProps, inputRecord_5.OnBlur, inputRecord_5.OnFocus, inputRecord_5.AutoComplete, inputRecord_5.Name)))), delay(() => {
                                let inputRecord_6;
                                return singleton_2(inputCheckbox((inputRecord_6 = CheckboxInput_get_getDefault(), new CheckboxInput(inputRecord_6.Disabled, getTranslation("Common.Active"), (e_6) => {
                                    isActiveState[1](Browser_Types_Event__Event_get_Checked(e_6));
                                }, isActiveState[0], "create-contract-is-active", inputRecord_6.HTMLProps))));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    }));
    bodyHtml = react.createElement("div", {
        id: "create-contract-modal",
    }, ...children_1);
    let cancelButtonProps;
    const inputRecord_7 = ButtonProps_get_getDefault();
    cancelButtonProps = (new ButtonProps(getTranslation("Common.Cancel"), inputRecord_7.Content, (_arg_7) => {
        modalIsOpen[1](false);
    }, inputRecord_7.Disabled, "create-contract-type-modal-cancel-btn", inputRecord_7.SaveStatus, inputRecord_7.HTMLProps, inputRecord_7.ExtraClasses, inputRecord_7.Icon));
    let acceptButtonProps;
    const inputRecord_8 = ButtonProps_get_getDefault();
    acceptButtonProps = (new ButtonProps(getTranslation("Common.Create"), inputRecord_8.Content, (_arg_10) => {
        const dto = new CreateContractTypeDTO(isActiveState[0], contractTypePriceIdState[0], displayState[0], networkContractNrState[0], strToOpt(priceListCodeState[0]), ProductModule_toInt(productNrState[0]));
        props.SaveFn([codeState[0], dto]);
        modalIsOpen[1](false);
        displayState[1]("");
        codeState[1]("");
        productNrState[1](new Product(0));
        networkContractNrState[1](void 0);
        priceListCodeState[1]("");
        contractTypePriceIdState[1](1);
        isActiveState[1](true);
    }, !(((arg_13 = (codeState[0]), Result_toBool(FSharpMap__get_Item(validationFields, new ValidationField(1))(arg_13)))) && ((arg_14 = (displayState[0]), Result_toBool(FSharpMap__get_Item(validationFields, new ValidationField(0))(arg_14))))), "create-contract-type-modal-accept-btn", inputRecord_8.SaveStatus, inputRecord_8.HTMLProps, inputRecord_8.ExtraClasses, inputRecord_8.Icon));
    const modalHtml = renderWithButtonProps(modalIsOpen[0], new ModalSize(0), getTranslation("Contracts.ContractType.CreateNewContractType"), bodyHtml, cancelButtonProps, acceptButtonProps);
    return react.createElement("div", {}, createContractTypeButtonHtml, modalHtml);
}, void 0, uncurry(2, void 0), void 0, "renderCreateContractTypeButtonAndModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\ContractType\\View.fs", 300);

export class ContractTypeProps extends Record {
    constructor(GlobalDependencies, CurrentPage) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.CurrentPage = CurrentPage;
    }
}

export function ContractTypeProps$reflection() {
    return record_type("Containers.ContractType.View.ContractTypeProps", [], ContractTypeProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["CurrentPage", Page$reflection()]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const allContractTypesState = react.useState(new LoadState$2(0));
    const selectedContractTypeCodeState = react.useState(void 0);
    const contractTypeState = react.useState(new LoadState$2(0));
    const errorMessageState = react.useState(void 0);
    const errorMessageState2 = react.useState(void 0);
    const loadAllContractTypes = () => {
        allContractTypesState[1](new LoadState$2(1));
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(loadAllContractTypes_1(props.GlobalDependencies.ClientNr), (_arg) => {
            const result = _arg;
            const arg_1 = (result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, sortBy((c1) => [!c1.Active, c1.Display.trim()], result.fields[0], {
                Compare: compareArrays,
            })));
            allContractTypesState[1](arg_1);
            return singleton_1.Zero();
        })));
    };
    const loadContractType = (contractTypeCode_1, errorMessage) => {
        contractTypeState[1](new LoadState$2(1));
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(loadContractType_1(props.GlobalDependencies.ClientNr, contractTypeCode_1), (_arg_2) => {
            const result_2 = _arg_2;
            const arg_4 = (result_2.tag === 1) ? (new LoadState$2(3, result_2.fields[0])) : (new LoadState$2(2, result_2.fields[0]));
            contractTypeState[1](arg_4);
            errorMessageState2[1](errorMessage);
            return singleton_1.Zero();
        })));
    };
    react.useEffect(() => {
        const matchValue = props.CurrentPage;
        let pattern_matching_result, contractTypeCode_2;
        switch (matchValue.tag) {
            case 1: {
                pattern_matching_result = 1;
                contractTypeCode_2 = matchValue.fields[0];
                break;
            }
            case 3: {
                pattern_matching_result = 1;
                contractTypeCode_2 = matchValue.fields[0];
                break;
            }
            case 2: {
                pattern_matching_result = 1;
                contractTypeCode_2 = matchValue.fields[0];
                break;
            }
            case 4: {
                pattern_matching_result = 1;
                contractTypeCode_2 = matchValue.fields[0];
                break;
            }
            case 5: {
                pattern_matching_result = 2;
                break;
            }
            default: pattern_matching_result = 0}
        switch (pattern_matching_result) {
            case 0: {
                selectedContractTypeCodeState[1](void 0);
                loadAllContractTypes();
                break;
            }
            case 1: {
                const matchValue_1 = selectedContractTypeCodeState[0];
                if (matchValue_1 != null) {
                    if (matchValue_1 !== contractTypeCode_2) {
                        const selectedContractTypeCode_1 = matchValue_1;
                        loadContractType(contractTypeCode_2, void 0);
                    }
                }
                else {
                    loadContractType(contractTypeCode_2, void 0);
                }
                selectedContractTypeCodeState[1](contractTypeCode_2);
                break;
            }
            case 2: {
                break;
            }
        }
    }, [props.CurrentPage]);
    react.useEffect(() => {
        const matchValue_2 = props.CurrentPage;
        let pattern_matching_result_1, contractTypeCode_3;
        switch (matchValue_2.tag) {
            case 1: {
                pattern_matching_result_1 = 1;
                contractTypeCode_3 = matchValue_2.fields[0];
                break;
            }
            case 3: {
                pattern_matching_result_1 = 1;
                contractTypeCode_3 = matchValue_2.fields[0];
                break;
            }
            case 2: {
                pattern_matching_result_1 = 1;
                contractTypeCode_3 = matchValue_2.fields[0];
                break;
            }
            case 4: {
                pattern_matching_result_1 = 1;
                contractTypeCode_3 = matchValue_2.fields[0];
                break;
            }
            case 5: {
                pattern_matching_result_1 = 2;
                break;
            }
            default: pattern_matching_result_1 = 0}
        switch (pattern_matching_result_1) {
            case 0: {
                selectedContractTypeCodeState[1](void 0);
                loadAllContractTypes();
                break;
            }
            case 1: {
                loadContractType(contractTypeCode_3, void 0);
                break;
            }
            case 2: {
                break;
            }
        }
    }, [props.GlobalDependencies]);
    const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
    const children_33 = toList(delay(() => {
        let children_31, children_16, children_18, children_25, matchValue_5, msg_4;
        const matchValue_3 = props.CurrentPage;
        switch (matchValue_3.tag) {
            case 1: {
                const contractTypeCode_4 = matchValue_3.fields[0];
                let errorMsg2Html;
                const matchValue_6 = errorMessageState2[0];
                if (matchValue_6 != null) {
                    const msg_5 = matchValue_6;
                    errorMsg2Html = error(msg_5.split(""));
                }
                else {
                    errorMsg2Html = react.createElement(react.Fragment, {});
                }
                return append(singleton_2(renderTopSection(new TopSectionProps(contractTypeState[0], props.CurrentPage, contractTypeCode_4))), delay(() => {
                    let children_29;
                    const matchValue_7 = contractTypeState[0];
                    switch (matchValue_7.tag) {
                        case 1: {
                            return singleton_2(dotsLoading);
                        }
                        case 3: {
                            return singleton_2(error(matchValue_7.fields[0].split("")));
                        }
                        case 2: {
                            return singleton_2((children_29 = [errorMsg2Html, view_1(new ContractTypeGeneralProps(props.GlobalDependencies, contractTypeCode_4, matchValue_7.fields[0], (errorMessage_1) => {
                                loadContractType(contractTypeCode_4, errorMessage_1);
                            }))], react.createElement("div", {
                                className: "contract-types",
                            }, ...children_29)));
                        }
                        default: {
                            return singleton_2(react.createElement(react.Fragment, {}));
                        }
                    }
                }));
            }
            case 3: {
                const contractTypeCode_5 = matchValue_3.fields[0];
                return append(singleton_2(renderTopSection(new TopSectionProps(contractTypeState[0], props.CurrentPage, contractTypeCode_5))), delay(() => singleton_2(view_2(new ActivationStateProps(props.GlobalDependencies.ClientNr, contractTypeCode_5)))));
            }
            case 2: {
                const contractTypeCode_6 = matchValue_3.fields[0];
                return append(singleton_2(renderTopSection(new TopSectionProps(contractTypeState[0], props.CurrentPage, contractTypeCode_6))), delay(() => singleton_2(view_3(new ContractTypeMortgageProps(props.GlobalDependencies.ClientNr, contractTypeCode_6)))));
            }
            case 4: {
                const contractTypeCode_7 = matchValue_3.fields[0];
                return append(singleton_2(renderTopSection(new TopSectionProps(contractTypeState[0], props.CurrentPage, contractTypeCode_7))), delay(() => singleton_2(renderSubproducts(new SubproductsProps(() => {
                    const a = ContractTypeSubproductApi_load(props.GlobalDependencies.ClientNr, contractTypeCode_7);
                    return singleton_1.Delay(() => singleton_1.Bind(a, (_arg_3) => singleton_1.Return(Result_Map((list_1) => map(NormalizedSubproduct_ofSubproductDTO_Z9763C53, list_1), _arg_3))));
                }, (name, product, activeFrom, normalizedSubproduct) => ContractTypeSubproductApi_update(props.GlobalDependencies.ClientNr, contractTypeCode_7, name, product, activeFrom, NormalizedSubproduct_toSubproductDTO_Z60DB963E(normalizedSubproduct)), (subproductName, product_1, activeFrom_1) => ContractTypeSubproductApi_delete(props.GlobalDependencies.ClientNr, contractTypeCode_7, subproductName, product_1, activeFrom_1), (arg_8) => ContractTypeSubproductApi_create(props.GlobalDependencies.ClientNr, contractTypeCode_7, NormalizedSubproduct_toSubproductDTO_Z60DB963E(arg_8)), () => loadSubproductDefinitions(props.GlobalDependencies.ClientNr), locale, new SubproductLevel(1), props.GlobalDependencies.IsAdminUser)))));
            }
            case 5: {
                return singleton_2((children_31 = [warning(getTranslation("ContractType.Overview.NotFound").split(""))], react.createElement("div", {}, ...children_31)));
            }
            default: {
                let headerHtml;
                const children = [getTranslation("Contracts.ContractType.ContractTypes")];
                headerHtml = react.createElement("h1", {
                    ["data-translation"]: "Contracts.ContractType.ContractTypes",
                }, ...children);
                let contractTypesTableHtml;
                const matchValue_4 = allContractTypesState[0];
                switch (matchValue_4.tag) {
                    case 1: {
                        contractTypesTableHtml = dotsLoading;
                        break;
                    }
                    case 3: {
                        contractTypesTableHtml = error(matchValue_4.fields[0].split(""));
                        break;
                    }
                    case 2: {
                        const children_20 = [renderCustomTable(ofArray([(children_16 = [getTranslation("Common.Name")], react.createElement("th", {
                            className: "head",
                            ["data-translation"]: "Common.Name",
                        }, ...children_16)), (children_18 = [getTranslation("Common.Code")], react.createElement("th", {
                            className: "head",
                            ["data-translation"]: "Common.Code",
                        }, ...children_18))]), map((contractType) => {
                            let children_10, children_8;
                            const href = RouterModule_encodeParts(append_1(RouterModule_urlSegments(window.location.hash, 1), singleton(contractType.ContractTypeCode)), 1);
                            const statusBallHtml = renderStatusBallHtml(getTranslation, contractType.Active);
                            const children_14 = [(children_10 = [(children_8 = [react.createElement("div", {
                                className: "mr-2",
                            }, statusBallHtml), react.createElement("a", {
                                href: href,
                                className: "contract-types__link",
                            }, contractType.Display)], react.createElement("div", {
                                className: "d-flex align-items-center",
                            }, ...children_8))], react.createElement("td", {
                                className: "cell",
                            }, ...children_10)), react.createElement("td", {
                                className: "cell",
                            }, contractType.ContractTypeCode)];
                            return react.createElement("tr", {}, ...children_14);
                        }, matchValue_4.fields[0]))];
                        contractTypesTableHtml = react.createElement("div", {
                            className: "mr-4 mb-4",
                        }, ...children_20);
                        break;
                    }
                    default: {
                        contractTypesTableHtml = react.createElement("p", {}, "...");
                    }
                }
                const createContractTypeButtonAndModalHtml = renderCreateContractTypeButtonAndModal(new CreateContractTypeProps((tupledArg) => {
                    startImmediate(singleton_1.Delay(() => singleton_1.Bind(createContractType(props.GlobalDependencies.ClientNr, tupledArg[0], tupledArg[1]), (_arg_1) => {
                        const result_1 = _arg_1;
                        if (result_1.tag === 1) {
                            errorMessageState[1](result_1.fields[0]);
                            return singleton_1.Zero();
                        }
                        else {
                            loadAllContractTypes();
                            return singleton_1.Zero();
                        }
                    })));
                }, () => loadPricelist(props.GlobalDependencies.ClientNr)));
                return singleton_2((children_25 = [headerHtml, (matchValue_5 = (errorMessageState[0]), (matchValue_5 != null) ? ((msg_4 = matchValue_5, error(msg_4.split("")))) : react.createElement(react.Fragment, {})), react.createElement("div", {
                    className: "d-flex",
                }, contractTypesTableHtml, createContractTypeButtonAndModalHtml)], react.createElement("div", {
                    className: "contract-types",
                }, ...children_25)));
            }
        }
    }));
    return react.createElement("section", {
        className: "container-main container-main--padded",
    }, ...children_33);
}, void 0, uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\ContractType\\View.fs", 561);

